'use client'
import {
  commonWhere
} from "./chunk-N55STAST.mjs";
import {
  LOCATION_QUERY
} from "./chunk-RJD7S7WV.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  gqlClient
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/experiences/listing.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var getExperiences = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(
      gql`
      query getExperiences($lang: String, $limit: Int, $skip: Int, $where: ExperienceFilter, $order: [ExperienceOrder]) {
        experienceCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
          total
          items {
            __typename
            sys { id }
            id
            title
            subtitle
            slug
            ticketingUrlSlug
            image11{${IMAGE_QUERY}}
            image31{${IMAGE_QUERY}}
            startingPrice
            discountedPrice
            currencyCode
            schedule{${SCHEDULE_QUERY}}
            isStreamingEvent
            zoneEntryIncluded
            buttonLabel
            cardButtonLabel
            eventType
            buttonLink
            zone{
              id slug title zoneLogo{${IMAGE_QUERY}} sponsorLogo{${IMAGE_QUERY}} 
            }
            location{${LOCATION_QUERY}}
            category{id title slug}
            isComingSoon
            organizationSlug
          }
        }
      }
    `,
      __spreadProps(__spreadValues({
        order: "order_ASC"
      }, props), {
        lang: getContentfulSafeLocale(props.lang),
        where: __spreadValues(__spreadValues({}, commonWhere), props.where)
      })
    );
    return __spreadProps(__spreadValues({}, res.experienceCollection), {
      settledAt: Date.now()
    });
  } catch (error) {
    throw new Exception({ error, name: "getExperiencesException" });
  }
});
var useGetExperiences = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getExperiences", props],
    queryFn: () => getExperiences(props)
  }, options));
};

export {
  getExperiences,
  useGetExperiences
};
//# sourceMappingURL=chunk-VUJ4G6A6.mjs.map